(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminEmailDisplaySettingsController', AdminEmailDisplaySettingsController);

    function AdminEmailDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        recurrenceRulesService,
        elbSettings,
        $state,
        module,
        modulesService
    ) {
        const vm = this;
        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'email_html_signature',
                'email_text_signature',
                'email_tenant_logo'
            ],
            recurrenceRulesService: recurrenceRulesService,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService
        });

        angular.extend(vm, base);
    }
})();
